import { AppBar, Box, Button, ClickAwayListener, Container, CssBaseline, Grid, Grow, Link, makeStyles, MenuItem, MenuList, Paper, Popper, Tab, Tabs, TextField, Theme, Toolbar, Typography, useMediaQuery } from '@material-ui/core';
import { Email, LocationOn, Phone, Send } from '@material-ui/icons';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import './App.css';
import { Dimosieuseis } from './Dimosieuseis';
import { Enotites } from './Enotites';
import { Foreis } from './Foreis';
import { XronodiagrammaParadoteon } from './XronodiagrammaParadoteon';

export const useAppStyles = makeStyles((theme) => ({
  toolbar: {
    //margin: '0 auto',
    width: '100%',
  },
  toolbarTitle: {
    //flex: 1,
  },
  toolbarSecondary: {
    // justifyContent: 'space-between',
    // overflowX: 'auto',
    color: theme.palette.common.white,
  },
  toolbarLink: {
    // padding: theme.spacing(1),
    // flexShrink: 0,
  },
  mainGrid: {
    marginTop: theme.spacing(3),
  },
  footer: {
    backgroundColor: 'rgb(34,34,34)',
    color: theme.palette.common.white,
    // marginTop: theme.spacing(8),
    padding: theme.spacing(6, 0),
  },
  container: {
  },
  main: {
    backgroundColor: 'rgb(249, 244, 236)',
    minHeight: '56vh'
  },
  appBar: {
    backgroundColor: 'rgb(34,34,34)',
  },
  communication: {
    marginTop: 9,
    marginRight: 8,
    marginBottom: -9,
    color: theme.palette.primary.main,
  },
  banner: {
    width: '100%'
  },
  menulist: {
    background: 'rgba(42, 42, 42, 1)',
    color: 'white',
    width: '156px',
  },
  menulistItem: {
    '&:hover': {
      background: 'rgba(34, 34, 34)',
      color: theme.palette.primary.light,
      fontWeight: 'bolder',
    },
  }
}));

type TabPanelProps = { index: number, value: number }

export const TabPanel: React.FC<TabPanelProps> = props => {
  return (
    props.index === props.value ? <Box p={3} component='div'>
      {props.children}
    </Box> : null
  )
}

export const App = () => {
  const classes = useAppStyles()
  const isLargeDisplay = useMediaQuery((theme: Theme) => theme.breakpoints.up('xl'));
  const history = useHistory()

  const [activeTab, setActiveTab] = useState(0)
  const [open, setOpen] = React.useState(false)
  const [activeDescription, setActiveDescription] = useState(0)

  const EMPTY_MESSAGE = { email: '', name: '', message: '', phone: '' }
  const [message, setMessage] = useState(EMPTY_MESSAGE)

  const anchorRef = React.useRef<HTMLAnchorElement | null>(null)

  const handleToggle = (e: any) => {
    setOpen((prevOpen) => !prevOpen);
  }

  const handleClose = (event: any) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  }

  function handleListKeyDown(event: any) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = useRef(open);

  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef?.current?.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const tabs = <Tabs value={activeTab} onChange={(_, v) => v !== 8 && v !== 1 && setActiveTab(v)} centered scrollButtons='on' variant="scrollable">
    <Tab value={8} color="inherit" className={classes.toolbarLink} wrapped={false} onClick={e => {
      history.push('/en')
    }}
      label={<Typography>ENGLISH</Typography>}
    />
    <Tab value={0} color="inherit" className={classes.toolbarLink} wrapped={false} label="ΑΡΧΙΚΗ" />
    <Tab value={1} color="inherit" className={classes.toolbarLink} wrapped={false} label="ΦΟΡΕΙΣ ΕΡΓΟΥ" ref={anchorRef as any} onClick={handleToggle} />
    <Tab value={2} color="inherit" className={classes.toolbarLink} wrapped={false} label="ΕΝΟΤΗΤΕΣ ΕΡΓΑΣΙΑΣ" />
    <Tab value={3} color="inherit" className={classes.toolbarLink} wrapped={false} label="ΧΡΟΝΟΔΙΑΓΡΑΜΜΑ ΠΑΡΑΔΟΤΕΩΝ" />
    <Tab value={4} color="inherit" className={classes.toolbarLink} wrapped={false} label="ΔΗΜΟΣΙEYΣΕΙΣ" />
    <Tab value={5} color="inherit" className={classes.toolbarLink} wrapped={false} label="ΔΕΛΤΙΑ ΤΥΠΟΥ & ΑΝΑΚΟΙΝΩΣΕΙΣ" />
    <Tab value={6} color="inherit" className={classes.toolbarLink} wrapped={false} label="ΕΚΔΗΛΩΣΕΙΣ" />
    <Tab value={7} color="inherit" className={classes.toolbarLink} wrapped={false} label="ΕΠΙΚΟΙΝΩΝΙΑ" />
  </Tabs>

  return (
    <div className="App">
      <CssBaseline />

      <AppBar position='sticky' className={classes.appBar}>
        <img src="/holea-final.png" alt="logo" className={classes.banner} />
        <Toolbar component="nav" variant='dense' className={classes.toolbar}>
          {isLargeDisplay ?
            <Grid container direction="column" alignItems="center" justify="center" style={{ width: '100%', }}>
              <Grid item>
                {tabs}
              </Grid>
            </Grid> : tabs}
        </Toolbar>
      </AppBar>
      <Container maxWidth="lg" className={classes.container}>

        <main className={classes.main}>
          <Popper style={{ zIndex: 10 }} open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
            {({ TransitionProps, placement }) => (
              <Grow {...TransitionProps} style={{ transformOrigin: 'center bottom' }} >
                <Paper>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown} className={classes.menulist}>
                      <MenuItem className={classes.menulistItem} onClick={e => { setActiveTab(1); handleClose(e) }}>Όλοι</MenuItem>
                      <MenuItem className={classes.menulistItem} onClick={e => { setActiveTab(1); setActiveDescription(0); handleClose(e) }}>ΤΦΧΦΠ</MenuItem>
                      <MenuItem className={classes.menulistItem} onClick={e => { setActiveTab(1); setActiveDescription(1); handleClose(e) }}>ΒΙΟΕΛΛΑΣ</MenuItem>
                      <MenuItem className={classes.menulistItem} onClick={e => { setActiveTab(1); setActiveDescription(2); handleClose(e) }}>ΜΕΛΑΣ</MenuItem>
                      <MenuItem className={classes.menulistItem} onClick={e => { setActiveTab(1); setActiveDescription(3); handleClose(e) }}>ΔΗΜΟΚΡΙΤΟΣ</MenuItem>
                      <MenuItem className={classes.menulistItem} onClick={e => { setActiveTab(1); setActiveDescription(4); handleClose(e) }}>ΕΚΕΤΑ</MenuItem>
                      <MenuItem className={classes.menulistItem} onClick={e => { setActiveTab(1); setActiveDescription(5); handleClose(e) }}>ΧΤΤΧΕΚΠΑ</MenuItem>
                      <MenuItem className={classes.menulistItem} onClick={e => { setActiveTab(1); setActiveDescription(6); handleClose(e) }}>ΓΠΑ</MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>


          <TabPanel value={activeTab} index={0}>
            <Typography variant='h5'>Περίληψη Πρότασης</Typography>
            <p>
              <Typography align='justify'>
                Το ελαιόλαδο και οι βρώσιμες ελιές αποτελούν εμπορικά προϊόντα με συνεχώς αυξανόμενη ζήτηση παγκοσμίως, λόγω τον πολύτιμων θρεπτικών τους συστατικών. Ωστόσο, η συνεχιζόμενη απαίτηση του καταναλωτικού κοινού προς την παραγωγή προϊόντων υψηλής διατροφικής αξίας ευνοούν πρακτικές  νοθείας, οι οποίες τα τελευταία χρόνια έχουν ενισχυθεί λόγω έλλειψης κατάλληλων συστημάτων ελέγχου ποιότητας. Με γνώμονα την προστασία του καταναλωτή από ανακριβείς ή παραπλανητικές επισημάνσεις σε προϊόντα ελιάς και ελαιολάδου η παρούσα Ερευνητική πρόταση στοχεύει αφενός στην ιχνηλασιμότητα των Ελληνικών ποικιλιών ελιάς προκειμένου να διασφαλισθεί η αρχική  προέλευση του προϊόντος, αφετέρου στη ανάπτυξη και εφαρμογή σύγχρονων μεθοδολογιών που θα διασφαλίζουν την ποιότητα της βρώσιμης ελιάς (χρήση αλκαλικού διαλύματος ή επεξεργασία με άλμη) όσο και την τεκμηρίωση του ισχυρισμό υγείας σε ελαιόλαδα που πληρούν τα κριτήρια της EFSA. Παράλληλα, θα επιχειρηθεί η ανάπτυξη πιστοποιημένων μεθοδολογιών για την διασφάλιση της ποιότητας των ΠΟΠ & ΠΓΕ ελαιολάδων από περιπτώσεις νοθείας, μέσω της ιχνηλασιμότητας των Ελληνικών ποικιλιών ελιάς και της γεωγραφικής τους προέλευσης. Για την επιτυχή ολοκλήρωση του έργου θα συνεργαστούν δύο εταιρίες με  σημαντική
                δραστηριότητα στον χώρο της παραγωγής, εμπορίας και προώθησης προϊόντων ελιάς καθώς και πέντε ερευνητικοί φορείς με αποδεδειγμένη εμπειρία στο πεδίο του ελαιολάδου, που θα δράσουν συμβουλευτικά αλλά και θα εκτελέσουν συγκεκριμένα ερευνητικά τμήματα της επικείμενης πρότασης. Τα επιδιωκόμενα αποτελέσματα της πρότασης εστιάζονται στην δημιουργία και εγκατάσταση ενός αξιόπιστου ιδιωτικού πρωτοκόλλου διασφάλισης ποιότητας με σκοπό τόσο τον ποιοτικό έλεγχο των προϊόντων ελιάς όσο και την διασφάλιση του καταναλωτή από περιπτώσεις νοθείας. Με δεδομένο ότι για την ελληνική οικονομία ο αγροδιατροφικός τομέας αποτελεί ή πρέπει να αποτελεί την κορωνίδα της ανάπτυξης και παραγωγικής ανασυγκρότησης της χώρας μας, είναι κάτι περισσότερο από επιβεβλημένο για την Ελλάδα να επενδύσει στην ποιότητα των αγροτικών της προϊόντων.
            </Typography>
            </p>
            <Typography align='justify'>
              <p>
                Η χρηματοδότηση για την υλοποίηση της παρούσας Πρότασης είναι 994.610,00 € εκ των οποίων η δημόσια δαπάνη ανέρχεται στα 945.580,00 €.
            </p>
            </Typography>
          </TabPanel>

          <TabPanel value={activeTab} index={1}>
            <Foreis activeDescription={activeDescription} />
          </TabPanel>

          <TabPanel value={activeTab} index={2}>
            <Enotites />
          </TabPanel>
          <TabPanel value={activeTab} index={3}>
            <XronodiagrammaParadoteon />
          </TabPanel>
          <TabPanel value={activeTab} index={4}>
            <Dimosieuseis />
          </TabPanel>
          <TabPanel value={activeTab} index={7}>
            <Grid container spacing={2}>

              <Grid item xs={12} sm={6}>
                <Typography variant='h5'>Στοιχεία επικοινωνίας</Typography>
                <p>
                  <Typography >
                    <br />
                    <br />
                Δρ. Παναγιώτης Σταθόπουλος <br />
                Τομέας Φαρμακογνωσίας και Χημείας Φυσικών Προϊόντων<br />
                Τμήμα Φαρμακευτικής<br />
                Εθνικό και Καποδιστριακό Πανεπιστήμιο Αθηνών<br />
                    <LocationOn className={classes.communication} />
                Πανεπιστημιούπολη, Ζωγράφου<br />
                15771, Αθήνα<br />
                    <Phone className={classes.communication} /> ΤΗΛΕΦΩΝΟ ΕΠΙΚΟΙΝΩΝΙΑΣ: 210 7274886<br />
                    <Email className={classes.communication} /> <Link href='mailto:stathopan@pharm.uoa.gr'>stathopan@pharm.uoa.gr</Link> <br />
                  </Typography>
                </p>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant='h5'>Επικοινωνήστε μαζί μας</Typography>
                <p>
                  <TextField value={message.name} onChange={e => setMessage({ ...message, name: e.target.value })} fullWidth label="Το όνομά σας" />
                  <TextField value={message.email} onChange={e => setMessage({ ...message, email: e.target.value })} type='email' fullWidth label="Το email σας" />
                  <TextField value={message.phone} onChange={e => /^\d{0,10}$/.test(e.target.value) && setMessage({ ...message, phone: e.target.value })} fullWidth label="Το τηλέφωνό σας" />
                  <TextField value={message.message} onChange={e => setMessage({ ...message, message: e.target.value })} fullWidth label="Το μήνυμά σας" multiline rows={5} />
                </p>
                <p>
                  <Button disabled={!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/.test(message.email) || message.message.length <= 3 || message.name.length <= 3} variant='contained' color='primary' startIcon={<Send />}
                    onClick={() => {
                      const req = new XMLHttpRequest()
                      req.onload = () => {
                        //if (req.status === 204) {
                        setMessage(EMPTY_MESSAGE)
                        //}
                      }
                      req.open('POST', 'https://techyotic-prod-holea.azurewebsites.net/api/ContactFormApi?code=QmkM3xCff5orJtu7LYdrJ4r/0NAYAX39MVNbObcxVSBVrut6OAfDBw==')
                      req.send(JSON.stringify(message))
                    }}>
                    Αποστολη
                  </Button>
                </p>
              </Grid>

            </Grid>



          </TabPanel>
        </main>
      </Container>

      <footer className={classes.footer}>
        <Container maxWidth="lg">
          <Typography variant="h6" align="center" gutterBottom>
            HOLEA
          </Typography>
          <Typography variant="body2" color="inherit" align="center">
            <Link color="inherit" href="https://holea.gr">
              holea
            {' © '}
            </Link>{' '}
            {new Date().getFullYear()}
            {'. Developed by techyotic.'}
          </Typography>
        </Container>
      </footer>

    </div>
  );
}

export default App;
